angular.module('wbDashboard').controller('SignupControllerAurea',
    ['$scope', '$timeout', '$window', 'User', 'Session', 'Track',
function ($scope, $timeout, $window, User, Session, Track) {
    $scope.pageData = {
        sending : false,
        status : null,
        errorMessage : null,
        success : false
    };

    $scope.forms = {};
    $scope.signup = {};

    $scope.signup.alias = $scope.$stateParams.alias;
    $scope.signup.referralCode = $scope.$stateParams.referralCode;
    if ($scope.signup.referralCode) {
        Session.set('referral', $scope.signup);
    } else {
        $scope.signup = Session.get('referral') || {};
        if ($scope.$stateParams.alias) {
            $scope.signup.alias = $scope.$stateParams.alias;
            if ($scope.signup.alias === 'rover') {
                $scope.signup.campaign = $scope.signup.alias;
            }
            Session.set('referral', $scope.signup);
        }
    }
    $scope.signup.paramHistory = Session.get('paramHistory') || {};

    $scope.referralName = $scope.signup.name;
    if ($scope.signup.referralCode && !$scope.referralName && $scope.referralName !== false) {
        User.signupReferralNameRequest($scope.signup.referralCode).then(function(name) {
            $scope.referralName = name;
            Session.get('referralName' + $scope.referralName);
        });
    }

    if ($scope.$stateParams.email) {
        $scope.signup.emailAddress = $scope.$stateParams.email;
        $scope.pageData.success = true;
        signupSubmit();
    }


    $scope.$watch('signup.emailAddress', function(email) {
        $scope.pageData.errorOption = null;
        $scope.pageData.errorMessage = null;
    });


    function signupSubmit(reset = false) {
        $scope.pageData.sending = true;
        $scope.pageData.errorOption = null;
        $scope.pageData.errorMessage = null;

        var data = angular.copy($scope.signup);

        if (typeof reset === "boolean") {
            data.reset = reset;
        }

        User.signupRequest(data).then(function (response) {
            $scope.pageData.errorMessage = null;
            $scope.pageData.success = true;
            Session.remove('referral');
            Session.remove('referralName');
            Session.remove('paramHistory');
            Track.send('Sign Up Email', 'email', {});

            if (response.data && response.data.code) {
                Track.gtm({'event': 'web_signup_request', 'userId': response.data.code});

                $scope.$state.go('.', {code: response.data.code}).then(function() {
                    //extra redirect to self with code in url for tracking
                    $timeout(function() {
                       $window.location.href = `/signup/${response.data.code}`;
                    }, 10);
                });
            }

        }).catch(function (response) {
            if (response.status === 418) {
                $scope.$state.go('public.login');
                return;
            } else if (response.status === 428) {
                //response.data.code //no longer need the code since otp entry was discarded
                //display to the user to check email or reset data
                $scope.pageData.errorOption = "otp_email";
            } else {
                $scope.pageData.errorMessage = "Either the email address was incorrect or there already exists an account with that email address";
                if (response.status) {
                    if (response.data && response.data.error && response.data.error.message) {
                        $scope.pageData.errorMessage = response.data.error.message;
                    } else if (response.data && response.data.data && response.data.data.message) {
                        //error format used in maintenance mode
                        $scope.pageData.errorMessage = response.data.data.message;
                    }
                }
            }
            $scope.pageData.success = false;

        }).finally(function() {
            $scope.pageData.sending = false;
        });
    }

    $scope.signupSubmit = signupSubmit;
    $scope.signupReset = function() {
        $scope.pageData.errorMessage = null;
        $scope.pageData.success = false;
        $scope.signup = {};
        $scope.forms.signup.$setPristine(true);
    };

}]);
